module.exports = __webpack_public_path__ + "img/logo-login.56bbce37.png";